import { Injector, StaticProvider } from '@angular/core';
import { PORTAL_DATA } from '@app/common/app-tokens';

export class PortalInjectorFactory {

  public static create(injector: Injector, dataToPass: any): Injector {
    const providers: StaticProvider[] = [
      { provide: PORTAL_DATA, useValue: dataToPass }
    ];
    return Injector.create({ parent: injector, providers: providers });
  }

}
